__turbopack_context__.v({
  "vimeoWrapper": "rGCN3a_vimeoWrapper",
});
